module.exports = __webpack_public_path__ + "img/res8.a775d6af.png";